export default "__VITE_ASSET__5fb67821__"